const appEnvironment = 'appEnvironment';
const hrisUrl = 'hrisUrl';
const isMultiLanguage = 'isMultiLanguage';
const isWorkplanIntegrationEnabled = 'isWorkplanIntegrationEnabled';
const version = 'version';
const authToken = 'authToken';
const jwtUserInfo = 'jwtUserInfo';
const jwtLifespan = 'jwtLifespan';
const userInitials = 'userInitials';

// eslint-disable-next-line import/prefer-default-export
export const SessionStorageKeys = Object.freeze({
    [appEnvironment]: appEnvironment,
    [hrisUrl]: hrisUrl,
    [isMultiLanguage]: isMultiLanguage,
    [isWorkplanIntegrationEnabled]: isWorkplanIntegrationEnabled,
    [version]: version,
    [authToken]: authToken,
    [jwtUserInfo]: jwtUserInfo,
    [jwtLifespan]: jwtLifespan,
    [userInitials]: userInitials,
});
